module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAjCAYAAADxG9hnAAAACXBIWXMAABcRAAAXEQHKJvM/AAAA3UlEQVRYw+2UsQ3CMBBFv6MIkS5SiozhNgUSk7AFYzBFNkFCovYWUESUIBpTpQk+584YSHG/tP3/PZ19Nt57UDpu7Nvm9uQMGJJ6DQUSCuIExnwxbxBkLowKTfUBQIFM4kJQKr5ZnPueAKDkHhxDp8UpGAmEqCNjQU4BCjpLR6YwsU6kTFzS+H4iMUhumLkrjYLkAOI+WnM775KKuL0LrtuD/f0/klMKoiAKIlUJANfhLjYOj2dwPSWrbSoUddebf3ej7nqzrKtpm0psvKxXZJt1ahREQRREQRRkiSAvf7xqUYYNdisAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu_icons/07.png
// module id = GDkk
// module chunks = 1